import React, { useState } from 'react';
import styled from 'styled-components';
import { useModalStore } from '../../../shared/store/portal/modalStore';
import { slideInFromLeftWeighted } from '../../../shared/component/Animation';
import HeadlessBtn from '../../../shared/component/headless/button/HeadlessBtn';
import { BlackFitBtn, PaperBlurFitBtn } from '../../../shared/component/headless/button/BtnBody';
import { getBtnName } from '../../../shared/constants/btnNames';
import { MemberFilterData } from '../../../shared/dto/EntityRepository';
import { useAdminMemberListStore } from '../../share/store/adminMemberStore';
import { getModalMessage } from '../../../shared/constants/modalMessages';
import FilterStationMemberIsPublic from './FilterStationMemberIsPublic';
import FilterStationMemberSubscription from './FilterStationMemberSubscription';
import FilterStationMemberLastLoginAt from './FilterStationMemberLastLoginAt';
import { paperTextureModal } from '../../../shared/component/paperTexture';


const FilterStationMemberModal: React.FC = () => {
  const { isClosing, clearModal } = useModalStore();
  const { filterData, setFilterData } = useAdminMemberListStore();
  const [currentFilter, setCurrentFilter] = useState<MemberFilterData>(filterData);

  if (!filterData) return null;

  const handleSubmit = () => {
    // Indexing을 참고하자!
    setFilterData(currentFilter);
    clearModal(400);
  }

  return (
    <LeftModalFrame
      onClick={(e) => e.stopPropagation()}
      $isClosing={isClosing}
    >
      <FilterStationComp>
        <FilterStationTitle>{getModalMessage('FILTER_STATION_TITLE')}</FilterStationTitle>
        <FilterStationMemberIsPublic currentFilter={currentFilter} setCurrentFilter={setCurrentFilter} />
        <FilterStationMemberSubscription currentFilter={currentFilter} setCurrentFilter={setCurrentFilter} />
        <FilterStationMemberLastLoginAt currentFilter={currentFilter} setCurrentFilter={setCurrentFilter} />
        <ButtonContainer>
          <HeadlessBtn
            value={getBtnName('APPLY')}
            handleClick={handleSubmit}
            StyledBtn={BlackFitBtn}
          />
          <HeadlessBtn
            value={getBtnName('CANCEL')}
            handleClick={() => clearModal(400)}
            StyledBtn={PaperBlurFitBtn}
          />
        </ButtonContainer>
      </FilterStationComp>
    </LeftModalFrame>
  );
};

const LeftModalFrame = styled.div<{ $isClosing: boolean }>`
  position: absolute;
  left: 4vw;
  width: 24vw;
  height: clamp(55vh, fit-content, 90vh);

  padding: 20px;

  opacity: ${({ $isClosing }) => ($isClosing ? 0 : 1)};
  transform: ${({ $isClosing }) =>
    $isClosing
      ? 'translateX(-100%)'
      : 'translateX(0)'
  };

  transition: all 0.6s ease-out;
  ${paperTextureModal}
  ${slideInFromLeftWeighted}
`;


const FilterStationComp = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: clamp(10px, 5vh, 30px);
`
const FilterStationTitle = styled.div`
  margin-bottom: 1.5vh;
  ${({ theme }) => theme.typography.Body_02_1};
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin: 10px 0px;
`;

export default FilterStationMemberModal;